// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__34U8H","itemTitle":"ClientEmergencyInfo_itemTitle__baAOE","itemText":"ClientEmergencyInfo_itemText__2CNlA"};